import React from 'react';
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://weavevo.com',
  realm: 'master',
  clientId: 'account'
});

function LoginPage({ setAuthenticated, setKeycloak, setToken }) {
  const handleLogin = () => {
    keycloak.init({ onLoad: 'login-required' }).then(auth => {
      if (auth) {
        setAuthenticated(true);
        setKeycloak(keycloak);
        setToken(keycloak.token);
      }
    });
  };

  return (
    <div className="container mt-5 text-center">
      <h2>Bienvenue sur Documentary App 🎬</h2>
      <p>Importez vos photos ou vidéos, générez un texte documentaire captivant, et partagez vos voyages et souvenirs.</p>
      <p className="text-light fs-5 mb-5">
          
        </p>
    </div>
  );
}

export default LoginPage;
